import { lazy } from 'react';

export const LazyAddressSelectorModal = lazy(() =>
  import('./address-selector-modal').then(module => ({ default: module.AddressSelectorModal })),
);
